import SystemEmailEditor from '@Components/General/SystemEmailEditor';
import { useTranslation } from 'react-i18next';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { emailDesignQueryOptions } from '@utils/queryOptions';

// TODO: Show uses

const EditEmailDesign = () => {
    const { t } = useTranslation();
    const { designId } = useParams({});

    const { data } = useSuspenseQuery(emailDesignQueryOptions(designId));

    const { mutate, isPending } = useMutation({
        mutationKey: ['updateEmailDesign'],
    });

    const handleSave = data => {
        return mutate([designId, data]);
    };

    return (
        <SystemEmailEditor
            initialData={data?.template || undefined}
            onSave={handleSave}
            saving={isPending}
            title={data?.title || t('Untitled Design')}
            setTitle={title => handleSave({ title })}
            selectTamplateOpen={!data?.template}
        />
    );
};

export default EditEmailDesign;
